import { useState } from 'react';

import { getValueWithCurrency } from '@/shared/lib';
import { Button, DashboardDialog, ScrollArea, Typography } from '@/shared/ui';

import { isAccountMethod } from '../lib/isAccountMethod';
import {
  NativePaymentMethods,
  PaymentMethod,
  PaymentMethodType,
} from '../model/types';
import {
  nativeAddPaymentItems,
  nativePaymentItemsTriggerInfo,
} from './native-payment-items';
import { NativePaymentMethodItem } from './native-payment-method-item';

interface PaymentMethodSelectProps {
  type: PaymentMethod;
  onSelect: (paymentMethod: PaymentMethod) => void;
  nativeMethods?: Partial<NativePaymentMethods>;
}
const PaymentMethodSelectContent = ({
  onSelect,
  nativeMethods = nativeAddPaymentItems,
}: Pick<PaymentMethodSelectProps, 'onSelect' | 'nativeMethods'>) => {
  return (
    <ScrollArea className="mt-2 max-h-[492px]">
      <div className="flex w-full flex-col gap-y-1 pb-1">
        <div className="flex flex-col gap-y-3 rounded-[28px] bg-base-300 px-4 py-3">
          {Object.entries(nativeMethods).map(([type, method]) => (
            <NativePaymentMethodItem
              onClick={() => {
                onSelect(type as PaymentMethodType);
              }}
              key={type}
              method={method}
            />
          ))}
        </div>
      </div>
    </ScrollArea>
  );
};
export const PaymentMethodSelect = ({
  type,
  onSelect,
  nativeMethods,
}: PaymentMethodSelectProps) => {
  const isAccount = isAccountMethod(type);
  const [isOpen, setIsOpen] = useState(false);
  const handleSelect = (method: PaymentMethod) => {
    onSelect(method);
    setIsOpen(false);
  };
  return (
    <div className="flex items-center justify-between rounded-[20px] bg-base-300 px-5 py-[18px]">
      <div className="flex items-center gap-4">
        {isAccount ? (
          <img
            src={type.account.imgSrc}
            alt={type.account.currencyName}
            className="max-h-6 max-w-6"
          />
        ) : (
          nativePaymentItemsTriggerInfo[type].icon
        )}
        <div className="flex flex-col gap-1">
          <Typography>
            {isAccount
              ? `${type.account.code} Account`
              : nativePaymentItemsTriggerInfo[type].title}
          </Typography>
          <Typography variant="13-r" color="text-base-100">
            {isAccount
              ? `${getValueWithCurrency(String(type.account.value), type.account.symbol)} available`
              : nativePaymentItemsTriggerInfo[type].description}
          </Typography>
        </div>
      </div>
      <DashboardDialog
        title="payment method"
        open={isOpen}
        onOpenChange={setIsOpen}
        contentClassName="py-0"
        animationProps={{
          isFirst: true,
        }}
        content={
          <PaymentMethodSelectContent
            onSelect={handleSelect}
            nativeMethods={nativeMethods}
          />
        }
      >
        <Button variant="brand-300" size="s">
          Change
        </Button>
      </DashboardDialog>
    </div>
  );
};
